import React from 'react';
import { Ghost, Twitter, Instagram, Youtube, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-void border-t border-white/5 pt-16 pb-8" data-id="element-39">
      <div className="max-w-7xl mx-auto px-6" data-id="element-40">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-41">
          <div className="col-span-1 md:col-span-2" data-id="element-42">
            <div className="flex items-center gap-3 mb-6" data-id="element-43">
              <Ghost className="w-6 h-6 text-mystic-500" data-id="element-44" />
              <span className="text-xl font-serif font-bold text-white tracking-widest" data-id="element-45">
                OMBRELUDIQUE
              </span>
            </div>
            <p className="text-gray-500 max-w-sm mb-6" data-id="element-46">
              Publishing the finest in interactive horror and mystery. Based in
              Limassol, Cyprus.
            </p>
            <div className="flex gap-4" data-id="element-47">
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-400 hover:bg-mystic-600 hover:text-white transition-all" data-id="element-48">
                <Twitter className="w-5 h-5" data-id="element-49" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-400 hover:bg-mystic-600 hover:text-white transition-all" data-id="element-50">
                <Instagram className="w-5 h-5" data-id="element-51" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-400 hover:bg-mystic-600 hover:text-white transition-all" data-id="element-52">
                <Youtube className="w-5 h-5" data-id="element-53" />
              </a>
            </div>
          </div>

          <div data-id="element-54">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-55">
              Navigation
            </h4>
            <ul className="space-y-4 text-gray-500 text-sm" data-id="element-56">
              <li data-id="element-57">
                <a href="#about" className="hover:text-mystic-400 transition-colors" data-id="element-58">
                  About Us
                </a>
              </li>
              <li data-id="element-59">
                <a href="#games" className="hover:text-mystic-400 transition-colors" data-id="element-60">
                  Games
                </a>
              </li>
              <li data-id="element-61">
                <a href="#services" className="hover:text-mystic-400 transition-colors" data-id="element-62">
                  Services
                </a>
              </li>
              <li data-id="element-63">
                <a href="#" className="hover:text-mystic-400 transition-colors" data-id="element-64">
                  Press Kit
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-65">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-66">
              Contact
            </h4>
            <ul className="space-y-4 text-gray-500 text-sm" data-id="element-67">
              <li className="flex items-center gap-2" data-id="element-68">
                <Mail className="w-4 h-4" data-id="element-69" />
                <a href="mailto:contact@ombreludique.com" className="hover:text-mystic-400 transition-colors" data-id="element-70">
                  contact@ombreludique.com
                </a>
              </li>
              <li data-id="element-71">
                <p data-id="element-72">Limassol, Cyprus</p>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-73">
          <p className="text-gray-600 text-sm" data-id="element-74">
            © 2026 Ombreludique. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-gray-600" data-id="element-75">
            <a href="#" className="hover:text-gray-400" data-id="element-76">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-gray-400" data-id="element-77">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}